// extracted by mini-css-extract-plugin
export var arrows = "_2t-6";
export var decrementer = "_2t-a";
export var disabled = "_2t-4";
export var error = "_2t-1";
export var hiddenText = "_2t-b";
export var incrementer = "_2t-9";
export var input = "_2t-8";
export var inputWrapper = "_2t-0";
export var leadingIcon = "_2t-c";
export var readonly = "_2t-3";
export var regular = "_2t-7";
export var small = "_2t-5";
export var warning = "_2t-2";